import * as React from "react";
function SvgIcSortDescending(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.86 13.45l-.376.648 4.646 2.683 4.646-2.683-.375-.649-3.896 2.25V6.513h-.75v9.184L7.86 13.45z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcSortDescending;
